import _ from "lodash";

export default {
    state: {
        list: null,

        count: null,

        filters: {
        },

        devices: null,
    },

    mutations: {
        FREECONNECTIONS_SET_LIST(state, list) {
            state.list = list
        },

        FREECONNECTIONS_SET_COUNT(state, count) {
            state.count = count
        },

        FREECONNECTIONS_SET_FILTER(state) {
            state.filters = {
            }
        },

        FREECONNECTIONS_RESET_FILTERS(state){
            state.filters = {
            }
        },

        SET_DEVICES(state, devices) {
            state.devices = devices
        }

    },

    getters: {
        mappedDevices(state) {
            let devices = [{id : null, nome : 'TODOS'}];
            if (state.devices){
                state.devices.forEach(function(item){
                    devices.push(item);
                })
            }

            return _.map(devices, (device) => {
                return {
                    id: device.id,
                    label: device.nome
                }
            })
        }
    }
}
